import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('widgetStore', Object.keys(state)),
	...mapGetters('widgetStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('widgetStore', Object.keys(actions)),
	...mapMutations('widgetStore', Object.keys(mutations))
};
